import { useEffect } from "react";
import AliceCarousel from "react-alice-carousel";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../Components/Public/Header";
import styles from "../Home/Home.module.scss";
import ManBaggage from "../../../Assets/images/man-with-baggage.png";
import Course from "../../../Assets/images/course.png";
import ImageCourse2 from "../../../Assets/images/course2.png";
import Image01 from "../../../Assets/images/image01.png";
import Image02 from "../../../Assets/images/image02.png";
import Image03 from "../../../Assets/images/image03.png";
import Image04 from "../../../Assets/images/image04.png";
import { Button } from "../../../Components/Button";
import "react-alice-carousel/lib/alice-carousel.css";
import "./styles.css";
import { ConteinerImage } from "./conteinerImage";
import { Footer } from "../../../Components/Public/Footer";
import { SectionDivision03 } from '../../../Components/Public/SectionDivision03';

import Testimony01 from "../../../Assets/images/testimony_1.png";
import Testimony02 from "../../../Assets/images/testimony_2.png";
import Testimony03 from "../../../Assets/images/testimony_3.png";
import Testimony04 from "../../../Assets/images/testimony_4.png";
import Testimony05 from "../../../Assets/images/testimony_5.png";
import { useTranslation } from 'react-i18next'
import { useLanguage } from "../../../contexts/LanguageContext";



export function Home() {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const { selectedLanguage } = useLanguage();

  const navigateWithReload = (path: string) => {
    window.location.href = path;
  };

  function handleWhatWeDo() {
    navigateWithReload("/o-que-fazemos");
  }

  function handleRegist() {
    navigateWithReload(`${process.env.REACT_APP_NEXT_INTAKE_URL}/subscribe?lang=${selectedLanguage}`)
  }

  function handleBeAnAffiliate() {
    navigateWithReload("/seja-um-afiliado");
  }

  function handleBeAPartner() {
    navigateWithReload("/seja-um-parceiro");
  }

  function handleInstitutionClick(index: number) {
    // Primeira (índice 0) - International Business University
    // Segunda (índice 1) - St Lawrence College
    // Terceira (índice 2) - Canadore College
    // Nona (índice 8) - Sheridan College
    if (index === 0) {
      window.open('https://app.nextintake.com/home?name_like=%20International%20Business%20University', '_blank');
    } else if (index === 1) {
      window.open('https://app.nextintake.com/home?&name_like=St%20Lawrence%20College', '_blank');
    } else if (index === 2) {
      window.open('https://app.nextintake.com/home?&name_like=Canadore%20College', '_blank');
    } else if (index === 8) {
      window.open('https://app.nextintake.com/home?&name_like=Sheridan%20College', '_blank');
    }
  }

  useEffect(() => {
    window.scroll(0, 1);
  }, []);

  const testimonies = [
    { avatar: Testimony01, name: 'Jorge de Andrade', location: t('home.depoimento1_location'), evaluation: 5, testimony: t('home.depoimento1') },
    { avatar: Testimony02, name: 'Helena Prado', location: t('home.depoimento2_location'), evaluation: 5, testimony: t('home.depoimento2') },
    { avatar: Testimony03, name: 'Gustavo Liber', location: t('home.depoimento3_location'), evaluation: 5, testimony: t('home.depoimento3') },
    { avatar: Testimony04, name: 'Hamilton Absy Junior', location: t('home.depoimento4_location'), evaluation: 5, testimony: t('home.depoimento4') },
    { avatar: Testimony05, name: 'Livia Almeida', location: t('home.depoimento5_location'), evaluation: 5, testimony: t('home.depoimento5') },
  ]

  const newItems = testimonies.map((item: any, index: any) => <ConteinerImage key={index} item={item} />)

  const items: any[] = [
    // <ConteinerImage key={1} />,
    // <ConteinerImage key={2} />,
    // <ConteinerImage key={3} />,
    // <ConteinerImage key={4} />,
    // <ConteinerImage key={5} />,
  ];

  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };

  const hidden = false;

  const brandIcons = [
    require('../../../Assets/images/icon/Institutions/Ibu-International-Business-University.jpeg'),
    require('../../../Assets/images/icon/Institutions/St-Lawrence-College.png'),
    require('../../../Assets/images/icon/Institutions/canadore-college-logo.png'),
    require('../../../Assets/images/icon/Institutions/Yorkville-University.jpeg'),
    require('../../../Assets/images/icon/Institutions/NYIT.png'),
    require('../../../Assets/images/icon/Institutions/red-logo.webp'),
    require('../../../Assets/images/icon/Institutions/Unisus.png'),
    require('../../../Assets/images/icon/Institutions/Centennial-College.jpg'),
    require('../../../Assets/images/icon/Institutions/Sheridan-College.png'),
    require('../../../Assets/images/icon/Institutions/Sault-College.png'),
  ];

  return (
    <div id="page-top">
      <Header />
      <header className={`masthead ${styles.division01}`}>
        <div className={`container px-5`}>
          <div className="row gx-5 align-items-center">
            <div className="col-lg-6">
              <div className="mb-5 mb-lg-0 text-center text-lg-start">
                <div className={`${styles.title01}`}>{t('home.title')}</div>
                <div className={`${styles.subTitle01}`}>
                  {t('home.subTitle')}
                </div>
                <div
                  className={`d-flex flex-column flex-lg-row align-items-center ${styles.btnDivision01} ${styles.deviceDivision01}`}
                >
                  <div
                    className="me-lg-3 mb-4 mb-lg-0"
                    onClick={handleWhatWeDo}
                  >
                    <Button name={t('home.button_o_que_fazemos')} typeButton="secondary" className={'w-full lg:w-auto'} />
                  </div>
                  <div onClick={handleRegist}>
                    <Button name={t('home.button_cadastre_agora')} typeButton="primary" className={'w-full lg:w-auto'} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="masthead-device-mockup">
                <img
                  src={ManBaggage}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                />
              </div>
            </div>
            <div
              className={`d-flex flex-lg-row mt-3 justify-content-center align-items-center flex-wrap ${styles.deviceDivision01_02}`}
            >
              <div className="me-lg-3 mb-lg-0 m-2" onClick={handleWhatWeDo}>
                <Button name={t('home.button_o_que_fazemos')} typeButton="secondary" className={'w-100'} isFullWidth />
              </div>
              <div className="m-2" onClick={handleRegist}>
                <Button name={t('home.button_cadastre_agora')} typeButton="primary" className={'w-100'} isFullWidth />
              </div>
            </div>
          </div>
        </div>
      </header>
      <section className={`text-center ${styles.division02}`}>
        <div className={`container px-5 ${styles.subContainer}`}>
          <div className="col-lg-12">
            <div className="mb-5 text-lg-start">
              <p className={`mb-5 ${styles.title02}`}>
              {t('home.title2')}
              </p>
            </div>
          </div>
          <div className={styles.cardYourBrand} style={{ marginTop: '64px' }}>
            <div className={`d-flex align-items-center justify-content-center flex-direction-row flex-wrap gap-4`}>
                {
                  brandIcons.map((icon, index) => (
                    <div
                      className={`d-flex align-items-center justify-content-center flex-direction-row flex-wrap ${styles.yourBrandHere}`}
                      key={index}
                      onClick={() => handleInstitutionClick(index)}
                      style={{
                        backgroundImage: `url(${icon})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        width: 100,
                        height: 100,
                        border: '2px solid #e0e0e0',
                        borderRadius: '50%',
                        backgroundColor: '#f9f9f9',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                        margin: '12px 0',
                        transition: 'all 0.2s',
                        cursor: (index === 0 || index === 1 || index === 2 || index === 8) ? 'pointer' : 'default',
                      }}
                    >
                    </div>
                  ))
                }
            </div>
          </div>
        </div>
      </section>
      <SectionDivision03 />
      <section className={styles.division04}>
        <div className={`container px-5`}>
          <div className="row gx-5 align-items-start">
            <div className="col-lg-6">
              <div className="mb-5 mb-lg-0 text-center text-lg-start">
                <div className={styles.title04}>{t('home.title4')}</div>
                <div className={styles.subTitle04}>
                  {t('home.subtitle4')}
                </div>
                <div className={`col-lg-6 ${styles.deviceDivision04_01}`}>
                  <div className="masthead-device-mockup">
                    <img
                      src={Image01}
                      style={{ width: "100%", height: "100%" }}
                      alt="Imagem"
                    />
                  </div>
                </div>
                {hidden && (
                  <div className="d-flex flex-column flex-lg-row align-items-center">
                    <a className="me-lg-3 mb-4 mb-lg-0" href="#!">
                      <Button
                        name={t('home.button_pesquise_outros_servicos')}
                        typeButton="secondary"
                        color="black"
                      />
                    </a>
                    <a href="#!">
                      <Button
                        name={t('home.button_pesquise_onde_estudar')}
                        typeButton="primary"
                      />
                    </a>
                  </div>
                )}
              </div>
            </div>
            <div className={`col-lg-6 ${styles.deviceDivision04}`}>
              <div className="masthead-device-mockup">
                <img
                  src={Image01}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.division05}>
        <div className={`container px-5`}>
          <div className={`row gx-5 align-items-start`}>
            <div className={`col-lg-6 ${styles.deviceDivision05}`}>
              <div className="masthead-device-mockup">
                <img
                  src={Image02}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                />
              </div>
            </div>
            <div className={`col-lg-6 ${styles.containerDivision05}`}>
              <div className="mb-lg-0 text-center text-lg-start">
                <div className={styles.title05}>{t('home.title5')}</div>
                <div className={styles.subTitle05}>
                  {t('home.subtitle5')}
                </div>
              </div>
            </div>
            <div className={`col-lg-6 ${styles.deviceDivision05_01}`}>
              <div className="masthead-device-mockup">
                <img
                  src={Image02}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.division06}>
        <div className={`masthead ${styles.container06ColorTop}`}>
          <div
            className={`gx-5 align-items-center ${styles.container06ColorTop_02}`}
          >
            <div className={`col-lg-6 ${styles.deviceDivision06}`}>
              <div className="masthead-device-mockup">
                <img
                  src={Image03}
                  className={styles.imageDivision06}
                  alt="Imagem"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 container px-5">
              <div className="mb-lg-0 text-center text-lg-start column ">
                <div className={`${styles.title06}`}>{t('home.title6')}</div>
                <div className={`${styles.subTitle06}`}>
                  {t('home.subtitle6_1')}
                  <br />
                  {t('home.subtitle6_2')}
                  <br />
                  {t('home.subtitle6_3')}
                  <br />
                  {t('home.subtitle6_4')}                                                
                </div>
                <div
                  className={`d-flex flex-column flex-lg-row align-items-center ${styles.deviceDivision06}`}
                >
                  <div
                    className="me-lg-3 mb-4 mb-lg-0"
                    onClick={handleBeAnAffiliate}
                  >
                    <Button
                      name={t('home.button_entenda_como')}
                      typeButton="secondary"
                      color="black"
                    />
                  </div>
                  <div onClick={handleRegist}>
                    <Button name={t('home.button_cadastre_agora')} typeButton="primary" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`col-lg-6 ${styles.deviceDivision06_01} ${styles.deviceDivision06_image}`}
            >
              <div className="masthead-device-mockup">
                <img
                  src={Image03}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                />
              </div>
            </div>
            <div
              className={`d-flex flex-column flex-wrap flex-lg-row mt-5 justify-content-center align-items-center ${styles.deviceDivision06_01} ${styles.deviceDivision06_btn}`}
            >
              <a className="me-lg-3 mb-lg-0 m-2" href="#!">
                <Button
                  name={t('home.button_entenda_como')}
                  typeButton="secondary"
                  color="black"
                  isFullWidth
                />
              </a>
              <a href="#!" className="m-2">
                <Button 
                  name={t('home.button_cadastre_agora')} 
                  typeButton="primary" 
                  isFullWidth
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.division07}>
        <div className={`container px-5`}>
          <div className="row gx-5 align-items-start">
            <div className="col-lg-6">
              <div className="mb-5 mb-lg-0 text-center text-lg-start">
                <div className={styles.title07}>{t('home.title7')}</div>
                <div className={styles.subTitle07}>
                  {t('home.subtitle7_1')}
                  {t('home.subtitle7_2')}
                  {t('home.subtitle7_3')}
                </div>
                <div
                  className={`d-flex flex-column flex-lg-row align-items-center ${styles.deviceDivision07}`}
                >
                  <div
                    className="me-lg-3 mb-4 mb-lg-0"
                    onClick={handleBeAPartner}
                  >
                    <Button name={t('home.button_entenda_como')} typeButton="secondary" />
                  </div>
                  <div onClick={handleRegist}>
                    <Button name={t('home.button_cadastre_agora')} typeButton="primary" />
                  </div>
                </div>
              </div>
            </div>
            <div className={`col-lg-6 ${styles.deviceDivision07_image}`}>
              <div className="masthead-device-mockup">
                <img
                  src={Image04}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                />
              </div>
            </div>
            <div
              className={`d-flex flex-column flex-wrap flex-lg-row mt-5 justify-content-center align-items-center ${styles.deviceDivision07_01}`}
            >
              <div className="me-lg-3 mb-lg-0 m-2" onClick={handleBeAPartner}>
                <Button
                  name={t('home.button_entenda_como')}
                  typeButton="secondary"
                  color="white"
                />
              </div>
              <div className="m-2" onClick={handleRegist}>
                <Button name={t('home.button_cadastre_agora')} typeButton="primary" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.containerCard08}>
        <div className={`px-5`}>
          <div className="row gx-5">
            <div className="col-lg-12">
              <div className={`mb-5 mb-lg-0 text-center carouselHome`}>
                <div className={styles.text08}>{t('home.title8')}</div>
                <AliceCarousel
                  mouseTracking
                  // items={items}
                  items={newItems}
                  responsive={responsive}
                  disableDotsControls={true}

                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.division09}>
        <div className={`masthead ${styles.division09ColorTop}`}>
          <div className="container px-5">
            <div className={styles.title09}>{t('home.title9')}</div>
            <div className={styles.subTitle09}>{t('home.subtitle9')}</div>
            <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center">
              <div className="me-lg-3 mb-4 mb-lg-0" onClick={handleRegist}>
                <Button name={t('home.button_cadastre_agora')} typeButton="primary" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
